import { useQuery } from "@tanstack/react-query";
import { fetchAreas } from "src/Pages/Company/OrganizationStructure/api";
import { retryQueryConfig } from "src/Pages/Company/OrganizationStructure/config/retryQueryConfig";

const useFetchAreas = (
  companyId: string,
  structureId: string,
  page: number,
  sortType: "asc" | "desc",
  search: string
) => {
  let filters: string | null = null;

  if (search !== "") {
    filters = `(areaName=like=*${search}*)`;
  }

  return useQuery({
    enabled: !!companyId && !!structureId,
    queryKey: ["areas-data", companyId, structureId, filters, page, sortType],
    queryFn: async ({ signal }) =>
      fetchAreas(
        companyId,
        structureId,
        {
          signal,
        },
        filters,
        page,
        sortType
      ),
    ...retryQueryConfig,
  });
};

export default useFetchAreas;
